export default __webpack_public_path__ + "static/media/bin-disabled-icon.3326f174.svg";